"use client";
import React, { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';

const sectors = [
{ num: '01', name: 'Infrastructure', image: "https://img.rocket.new/generatedImages/rocket_gen_img_18bab3843-1770100588254.png", alt: 'Modern city infrastructure with bridges and roads' },
{ num: '02', name: 'Construction', image: "https://images.unsplash.com/photo-1696690955152-90802be11048", alt: 'Construction site with cranes and steel framework' },
{ num: '03', name: 'Oil & Gas', image: "https://img.rocket.new/generatedImages/rocket_gen_img_17f36a980-1772147251673.png", alt: 'Oil and gas refinery with industrial pipes at sunset' },
{ num: '04', name: 'Shutdown & Turnaround', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ff6e77cd-1772906007462.png", alt: 'Industrial plant maintenance during shutdown operations' },
{ num: '05', name: 'Logistics', image: "https://img.rocket.new/generatedImages/rocket_gen_img_10ebeb567-1768341361205.png", alt: 'Logistics warehouse with forklifts and shipping containers' },
{ num: '06', name: 'Airport', image: "https://img.rocket.new/generatedImages/rocket_gen_img_164dd2388-1767775207570.png", alt: 'Modern airport terminal with planes on tarmac' },
{ num: '07', name: 'Seaport', image: "https://images.unsplash.com/photo-1698862070748-30ec9de62d01", alt: 'Container ship at a busy seaport with cranes' },
{ num: '08', name: 'Railways', image: "https://images.unsplash.com/photo-1711191652098-feb99ab77739", alt: 'Modern railway tracks with a high-speed train' },
{ num: '09', name: 'Stadium', image: "https://images.unsplash.com/photo-1553781137-34f22ccfa948", alt: 'Modern sports stadium with lighting and seating' },
{ num: '10', name: 'Operations & Maintenance', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1987c125c-1772840540968.png", alt: 'Maintenance technician inspecting industrial equipment' },
{ num: '11', name: 'Power & Utility', image: "https://img.rocket.new/generatedImages/rocket_gen_img_166ee2855-1772906005291.png", alt: 'Power transmission towers and electrical infrastructure' },
{ num: '12', name: 'Hospitality', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b1659249-1772906008176.png", alt: 'Luxury hotel lobby with elegant interior design' }];


export default function SectorsGrid() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-hidden').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="sectors" ref={ref} className="relative py-24 overflow-hidden" style={{ background: '#020d1f' }}>
      <div className="dot-grid absolute inset-0 opacity-20 pointer-events-none" />
      <div
        className="glow-orb w-[400px] h-[400px] bottom-0 right-0 opacity-25"
        style={{ background: 'rgba(0,194,255,0.25)' }} />
      
      <div className="max-w-[1280px] mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-16 reveal-hidden">
          <p className="eyebrow mb-4">INDUSTRIES</p>
          <h2
            className="text-3xl lg:text-5xl font-extrabold text-fg"
            style={{ fontFamily: 'Syne, sans-serif' }}>
            
            Sectors We{' '}
            <span className="gradient-text">Power</span>
          </h2>
        </div>

        {/* 4-column grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {sectors?.map((sector, i) =>
          <div
            key={sector?.num}
            className={`reveal-hidden stagger-${Math.min(i % 4 + 1, 6)} sector-card rounded-xl overflow-hidden cursor-pointer`}
            style={{ height: '200px' }}>
            
              <div className="relative w-full h-full">
                <AppImage
                src={sector?.image}
                alt={sector?.alt}
                fill
                className="object-cover sector-img"
                sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 25vw" />
              
                {/* Dark + blue overlay */}
                <div
                className="absolute inset-0 transition-opacity duration-300"
                style={{ background: 'linear-gradient(to top, rgba(2,13,31,0.9) 0%, rgba(2,13,31,0.4) 100%)' }} />
              
                {/* Content */}
                <div className="absolute inset-0 flex flex-col justify-end p-4">
                  <span
                  className="text-xs font-bold uppercase tracking-[2px] mb-1"
                  style={{
                    fontFamily: 'Plus Jakarta Sans, sans-serif',
                    color: 'rgba(0,194,255,0.7)'
                  }}>
                  
                    {sector?.num}
                  </span>
                  <h3
                  className="text-fg font-bold text-sm leading-tight"
                  style={{ fontFamily: 'Syne, sans-serif' }}>
                  
                    {sector?.name}
                  </h3>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}